import { render, staticRenderFns } from "./PrevStep.vue?vue&type=template&id=57758d90&"
import script from "./PrevStep.vue?vue&type=script&lang=js&"
export * from "./PrevStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PrevStep.vue"
export default component.exports